<opac-dialog #dialog [size]="'small'">
  <opac-button
    slot="header"
    (click)="close(false)"
    [ariaLabel]="'common.close' | translate" [opacTooltip]="'common.close' | translate">
    <opac-icon slot="only-icon" icon="close"></opac-icon>
  </opac-button>

  <opac-no-results
    [label]="(!isRecommendButtonPressed() ? 'user.recommend.dialog.title.text' : 'user.recommend.dialog.title.accept' ) | translate">
    <opac-no-results-recommend slot="custom-svg"></opac-no-results-recommend>
  </opac-no-results>

  <p *ngIf="!isRecommendButtonPressed()">{{ 'user.recommend.dialog.msg' | translate }}</p>

  <div *ngIf="!isRecommendButtonPressed()" slot="actions" class="actions">
    <opac-button (click)="recommendPlatform()"> {{ 'user.recommend.dialog.button.accept' | translate }} </opac-button>
    <opac-button type="secondary" (click)="close(false)">
      {{ 'user.recommend.dialog.button.reject' | translate }}
    </opac-button>
    <opac-button type="text" class="remind-later-button" (click)="close(true)">
      {{ 'general.later' | translate }}
    </opac-button>
  </div>

  <div *ngIf="isRecommendButtonPressed()" class="buttons-wrapper">
    <app-social-button
      *ngFor="let config of configs()"
      [config]="config"
      [title]="title"
      [description]="recommendationDialogInfo()?.recommendationMessage"
      [url]="url"
      [location]="'PLATFORM'"></app-social-button>
  </div>
</opac-dialog>
